import ContentLoader from 'react-content-loader';
import { HeadingLoader } from '../Heading/HeadingLoader';

const SKELETON_COUNT = 6;

export const WeatherCarouselLoader = () => (
  <div className="flex flex-col gap-6 overflow-hidden sm:gap-10">
    <HeadingLoader
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      width="450px"
      uniqueKey="weather-carousel-title-loader"
      variant="sm"
    />
    <div className="flex size-full flex-row gap-4">
      {Array.from({ length: SKELETON_COUNT }).map((_, id) => (
        <div
          key={`weather-carousel-${id}`}
          className="w-col-2 min-w-col-2 sm:w-col-3 sm:min-col-3 size-full md:w-auto md:min-w-auto"
        >
          <ContentLoader
            uniqueKey={`weathercarousel-loader-${id}`}
            id={`weathercarousel-loader-${id}`}
            speed={2}
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            className="h-28 w-full"
          >
            <rect x="0" y="0" width="100%" height="100%" />
          </ContentLoader>
        </div>
      ))}
    </div>
  </div>
);
